import { Typography, Card, CardContent, Box } from "@mui/material";

const PageSuccess = () => {
    return(
        <Card>
             <CardContent>
                <Box>
                    <Typography align='center' variant="h4" sx={{ mb: 2, mt: 2 }}>
                        Оплата по вашему заказу # <br/>не была получена
                    </Typography> 
                    <Box display='flex' justifyContent='center' alignItems='center'>
                    <svg width="100px" height="100px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-1.5-5.009c0-.867.659-1.491 1.491-1.491.85 0 1.509.624 1.509 1.491 0 .867-.659 1.509-1.509 1.509-.832 0-1.491-.642-1.491-1.509zM11.172 6a.5.5 0 0 0-.499.522l.306 7a.5.5 0 0 0 .5.478h1.043a.5.5 0 0 0 .5-.478l.305-7a.5.5 0 0 0-.5-.522h-1.655z" fill="#ff4c4c"/></svg>                    </Box>
                </Box>
             </CardContent>
        </Card>
    )
}

export default PageSuccess;